import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'
import { V2EmcLegislationBriefingStepShell } from './V2EmcLegislationBriefingStepShell'

export function V2EmcProductDescriptionStep({
  step,
  index,
  description,
  hasProductDescription,
  canWrite,
  onEditDescription,
}: {
  step: EmcBriefingStep
  index: number
  description: string | null | undefined
  hasProductDescription: boolean
  canWrite: boolean
  onEditDescription: () => void
}) {
  const { t } = useTranslation('common')

  let descriptionText = t(
    'v2.pages.products.detail.emcBriefing.productDescription.noDescription'
  )
  if (hasProductDescription && description != null) {
    descriptionText = description
  }

  return (
    <V2EmcLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        canWrite ? (
          <Button
            type='button'
            size='sm'
            variant='outline'
            onClick={onEditDescription}
          >
            {t('v2.pages.products.detail.emcBriefing.productDescription.action')}
          </Button>
        ) : undefined
      }
    >
      <p className='whitespace-pre-wrap text-sm text-muted-foreground'>
        {descriptionText}
      </p>
    </V2EmcLegislationBriefingStepShell>
  )
}
